import { AppLoader } from "globalComponents";
import useHandoff from "./useHandoff";

const Handoff = () => {
  useHandoff();
  return <AppLoader />;
};

export default Handoff;
